import { Text } from '@auviknetworks/iceberg-ui';
import { Box, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { Form } from 'application/Shared/Components/Form';
import { ModalFormFooter } from 'application/Shared/Modals';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Step } from './Forms/components/Step';

export const UseIntegrationSelector = ({
    handleUseAnIntegrationMethodChange,
    setUseIntegrationSubmitted,
    useAnIntegrationMethod,
    useIntegrationWizard,
    onSuccess
}) => {
    const { t } = useTranslation();

    return (
        <Box data-testid="useIntegrationSelector">
            <Form
                defaultValues={{}}
                onSubmit={() => setUseIntegrationSubmitted(true)}
            >
                <Box mx="24px" my="24px">
                    {!useIntegrationWizard ? (
                        <Step
                            number="1"
                            details={t('Integrations.ask_use_integration')}
                            margins="0px"
                        />
                    ) : (
                        <Text>{t('Integrations.ask_use_integration')}</Text>
                    )}
                    <RadioGroup
                        row
                        value={useAnIntegrationMethod}
                        onChange={(e) =>
                            handleUseAnIntegrationMethodChange(
                                e.currentTarget.value
                            )
                        }
                    >
                        <FormControlLabel
                            key="yes"
                            value="true"
                            control={<Radio />}
                            label={t('Common.yes')}
                        />
                        <FormControlLabel
                            key="no"
                            value="false"
                            control={<Radio />}
                            label={t('Common.no')}
                        />
                    </RadioGroup>
                </Box>
                {useIntegrationWizard && (
                    <ModalFormFooter
                        onClose={onSuccess}
                        onSubmitBtnText={t('Common.next')}
                    />
                )}
            </Form>
        </Box>
    );
};
